<template>
  <page-container title="Projects">
    <v-row class="ma-0 mb-2 pa-2 tab-header" align-content="center">
      <v-tabs v-model="selectedTab" height="36">
        <v-tab>Project list</v-tab>
        <v-tab>Archived</v-tab>
        <v-spacer></v-spacer>
        <feature name="projects" variant="write" data="projects">
          <v-btn
            color="primary"
            class="text-none button"
            tile
            :to="{ name: 'project-details', params: { id: 'new' } }"
            >New project</v-btn
          >
        </feature>
      </v-tabs>
    </v-row>
    <v-row class="ma-0">
      <v-card elevation="0" min-width="100%">
        <common-data-table
          :headers="headers"
          collectionName="projects"
          @click:row="rowClicked"
          :key="selectedTab"
          extraSortBy="archived"
          :search="[['archived', '!=', selectedTab == 0]]"
        >
        </common-data-table>
      </v-card>
    </v-row>
  </page-container>
</template>

<script>
import PageContainer from '@/components/PageContainer.vue'
import CommonDataTable from '@/components/CommonDataTable.vue'

export default {
  components: {
    PageContainer,
    CommonDataTable,
  },
  data: () => ({
    selectedTab: 0,
    headers: [
      {
        text: 'Project name',
        value: 'name',
      },
      // TODO: [CW-128] Active jobs count for a project
      // {
      //   text: 'Active jobs',
      //   value: 'active_jobs_count'
      // }
    ],
  }),
  computed: {
    status() {
      switch (this.selectedTab) {
      case 0:
        return 'In progress'
      case 1:
        return 'To do'
      case 2:
        return 'Completed'
      default:
        return undefined
      }
    },
  },
  methods: {
    rowClicked(data) {
      this.$router.push({
        name: 'project-details',
        params: { id: data.id },
      })
    },
  },
}
</script>
